interface Props {
    children: React.ReactNode;
    width?: number;
    height?: number;
}

export function KeyboardKey(props: Props) {
    const {children, width = 12, height = 12} = props;

    return (
        <div
            className='flex align-center justify-center pad-4 br-3 background-offwhite'
            style={{width, height}}
        >
            {children}
        </div>
    );
}
